import React from "react";
import { Modal } from "react-bootstrap";
import { CommissionDownloadForm } from "../forms/MyAccount/CommissionDownloadForm";

const CommissionDownloadModal = (props) => {
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey text-center">Download Commissions Statement</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CommissionDownloadForm refetch={props.refetch} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CommissionDownloadModal;
